export enum PatientStatus {
  Active = 'active',
  Inactive = 'inactive',
  Delete = 'deleted',
}
